module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"Accounts\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/accounts.component.html
// module id = ./src/app/accounts/accounts.component.html
// module chunks = main